import { Injectable } from '@angular/core';
import { Uf } from 'src/app/model/uf';
import { BaseClientService } from './base-client.service';

@Injectable({
  providedIn: 'root'
})
export class UfService {

  constructor(private client: BaseClientService) { }

  async listUf(): Promise<Uf[]> {
    return await this.client.get('/uf').toPromise();
  }
}
